import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { WContainer } from '@next-nx/shared-ui/atoms'
import { NoleggioStepCanoneAnimation, NoleggioStepCarouselAnimation, NoleggioStepOffertaAnimation } from '@next-nx/shared-ui/molecules' 
import styles from './NoleggioStepsHome.module.sass'


interface Props {
  item?: MenuItemType | undefined
  className?: string
}

const NoleggioStepsHome = (props: Props) => {

  const { 
    item = undefined,
    className = '',
  } = props

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <p className={styles.title}>{item.name}</p>
        {!!item.children?.edges?.length && (
          <div className={styles.list}>
            {item.children.edges.map(x => x.node).map(x => (
              <div key={x.pk} className={`${styles.item} ${x.style ? styles[`item--${x.style}`] : ''}`}>
                <div className={styles.itemAnimationWrap}>
                  <div className={styles.itemAnimationBg} />
                  <div className={styles.itemAnimationBox}>
                    {x.style === 'carousel' && (
                      <NoleggioStepCarouselAnimation
                        title1={x.children?.edges?.[0]?.node?.name || ''}
                        image1={x.children?.edges?.[0]?.node?.image || ''}
                        title2={x.children?.edges?.[1]?.node?.name || ''}
                        image2={x.children?.edges?.[1]?.node?.image || ''}
                      />
                    )}
                    {x.style === 'offerta' && (
                      <NoleggioStepOffertaAnimation item={x}/>
                    )}
                    {x.style === 'canone' && (
                      <NoleggioStepCanoneAnimation />
                    )}
                  </div>
                </div>
                <div className={styles.itemContent}>
                  {!!x.name && <p className={styles.itemTitle}>{x.name}</p>}
                  {!!x.description && <div className={styles.itemDescription} dangerouslySetInnerHTML={{ __html: x.description }} />}
                </div>
              </div>
            ))}
          </div>
        )}
      </WContainer>
    </div>
  ) : <></>
}

export default NoleggioStepsHome
